import script from "./LinkModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkModal.vue?vue&type=script&setup=true&lang=js"

import "./LinkModal.vue?vue&type=style&index=0&id=5d039eba&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d039eba"]])

export default __exports__